import { Dispatch, SetStateAction, useState } from "react";
import { Box } from "@mui/material";
import SearchBar from "../../components/SearchBar";
import { isValidInput } from "../../utils/validations";

const CustomerTopbar = ({
  searchTerm,
  setSearchTerm,
  debouncedSearchTerm,
  setDebouncedSearchTerm,
}: {
  searchTerm: string;
  setSearchTerm: Dispatch<SetStateAction<string>>;
  debouncedSearchTerm: string;
  setDebouncedSearchTerm: Dispatch<SetStateAction<string>>;
}) => {
  return (
    <>
      <div className="left_s">
        <Box className="search_box">
          <SearchBar
            searchTerm={searchTerm}
            placeholder="Search...."
            setDebouncedSearchTerm={setDebouncedSearchTerm}
            value={searchTerm}
            onCross={() => setSearchTerm("")}
            onChange={(val: any) => {
              if (isValidInput(val.target.value)) {
                setSearchTerm(val.target.value);
              }
            }}
          />
        </Box>
      </div>
    </>
  );
};

export default CustomerTopbar;
